/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AcceptanceDeadline } from './AcceptanceDeadline';
import {
    AcceptanceDeadlineFromJSON,
    AcceptanceDeadlineFromJSONTyped,
    AcceptanceDeadlineToJSON,
} from './AcceptanceDeadline';
import type { AdditionalComments } from './AdditionalComments';
import {
    AdditionalCommentsFromJSON,
    AdditionalCommentsFromJSONTyped,
    AdditionalCommentsToJSON,
} from './AdditionalComments';
import type { AppraisalPeriodDays } from './AppraisalPeriodDays';
import {
    AppraisalPeriodDaysFromJSON,
    AppraisalPeriodDaysFromJSONTyped,
    AppraisalPeriodDaysToJSON,
} from './AppraisalPeriodDays';
import type { BuyerAgentBrokerage } from './BuyerAgentBrokerage';
import {
    BuyerAgentBrokerageFromJSON,
    BuyerAgentBrokerageFromJSONTyped,
    BuyerAgentBrokerageToJSON,
} from './BuyerAgentBrokerage';
import type { BuyerAgentCommissionFlatCents } from './BuyerAgentCommissionFlatCents';
import {
    BuyerAgentCommissionFlatCentsFromJSON,
    BuyerAgentCommissionFlatCentsFromJSONTyped,
    BuyerAgentCommissionFlatCentsToJSON,
} from './BuyerAgentCommissionFlatCents';
import type { BuyerAgentCommissionPercentage1 } from './BuyerAgentCommissionPercentage1';
import {
    BuyerAgentCommissionPercentage1FromJSON,
    BuyerAgentCommissionPercentage1FromJSONTyped,
    BuyerAgentCommissionPercentage1ToJSON,
} from './BuyerAgentCommissionPercentage1';
import type { BuyerAgentEmail } from './BuyerAgentEmail';
import {
    BuyerAgentEmailFromJSON,
    BuyerAgentEmailFromJSONTyped,
    BuyerAgentEmailToJSON,
} from './BuyerAgentEmail';
import type { BuyerAgentFullName } from './BuyerAgentFullName';
import {
    BuyerAgentFullNameFromJSON,
    BuyerAgentFullNameFromJSONTyped,
    BuyerAgentFullNameToJSON,
} from './BuyerAgentFullName';
import type { BuyerAgentLicenseNumber } from './BuyerAgentLicenseNumber';
import {
    BuyerAgentLicenseNumberFromJSON,
    BuyerAgentLicenseNumberFromJSONTyped,
    BuyerAgentLicenseNumberToJSON,
} from './BuyerAgentLicenseNumber';
import type { BuyerAgentPhone } from './BuyerAgentPhone';
import {
    BuyerAgentPhoneFromJSON,
    BuyerAgentPhoneFromJSONTyped,
    BuyerAgentPhoneToJSON,
} from './BuyerAgentPhone';
import type { BuyerEmail } from './BuyerEmail';
import {
    BuyerEmailFromJSON,
    BuyerEmailFromJSONTyped,
    BuyerEmailToJSON,
} from './BuyerEmail';
import type { BuyerHomeMlsId } from './BuyerHomeMlsId';
import {
    BuyerHomeMlsIdFromJSON,
    BuyerHomeMlsIdFromJSONTyped,
    BuyerHomeMlsIdToJSON,
} from './BuyerHomeMlsId';
import type { BuyerPhone } from './BuyerPhone';
import {
    BuyerPhoneFromJSON,
    BuyerPhoneFromJSONTyped,
    BuyerPhoneToJSON,
} from './BuyerPhone';
import type { BuyerRepresentation } from './BuyerRepresentation';
import {
    BuyerRepresentationFromJSON,
    BuyerRepresentationFromJSONTyped,
    BuyerRepresentationToJSON,
} from './BuyerRepresentation';
import type { ClientProposedTermsRequestBuyerAgentCommissionSource } from './ClientProposedTermsRequestBuyerAgentCommissionSource';
import {
    ClientProposedTermsRequestBuyerAgentCommissionSourceFromJSON,
    ClientProposedTermsRequestBuyerAgentCommissionSourceFromJSONTyped,
    ClientProposedTermsRequestBuyerAgentCommissionSourceToJSON,
} from './ClientProposedTermsRequestBuyerAgentCommissionSource';
import type { ClientProposedTermsRequestHomeWarrantyPaidBy } from './ClientProposedTermsRequestHomeWarrantyPaidBy';
import {
    ClientProposedTermsRequestHomeWarrantyPaidByFromJSON,
    ClientProposedTermsRequestHomeWarrantyPaidByFromJSONTyped,
    ClientProposedTermsRequestHomeWarrantyPaidByToJSON,
} from './ClientProposedTermsRequestHomeWarrantyPaidBy';
import type { ConcessionsFlatCents } from './ConcessionsFlatCents';
import {
    ConcessionsFlatCentsFromJSON,
    ConcessionsFlatCentsFromJSONTyped,
    ConcessionsFlatCentsToJSON,
} from './ConcessionsFlatCents';
import type { ConcessionsPercentage1 } from './ConcessionsPercentage1';
import {
    ConcessionsPercentage1FromJSON,
    ConcessionsPercentage1FromJSONTyped,
    ConcessionsPercentage1ToJSON,
} from './ConcessionsPercentage1';
import type { CreateOfferRequestSource } from './CreateOfferRequestSource';
import {
    CreateOfferRequestSourceFromJSON,
    CreateOfferRequestSourceFromJSONTyped,
    CreateOfferRequestSourceToJSON,
} from './CreateOfferRequestSource';
import type { DownPayment } from './DownPayment';
import {
    DownPaymentFromJSON,
    DownPaymentFromJSONTyped,
    DownPaymentToJSON,
} from './DownPayment';
import type { DueDiligenceFee } from './DueDiligenceFee';
import {
    DueDiligenceFeeFromJSON,
    DueDiligenceFeeFromJSONTyped,
    DueDiligenceFeeToJSON,
} from './DueDiligenceFee';
import type { FinancingPeriodDays } from './FinancingPeriodDays';
import {
    FinancingPeriodDaysFromJSON,
    FinancingPeriodDaysFromJSONTyped,
    FinancingPeriodDaysToJSON,
} from './FinancingPeriodDays';
import type { FinancingType } from './FinancingType';
import {
    FinancingTypeFromJSON,
    FinancingTypeFromJSONTyped,
    FinancingTypeToJSON,
} from './FinancingType';
import type { HomeWarranty } from './HomeWarranty';
import {
    HomeWarrantyFromJSON,
    HomeWarrantyFromJSONTyped,
    HomeWarrantyToJSON,
} from './HomeWarranty';
import type { HomeWarrantyAmountCents } from './HomeWarrantyAmountCents';
import {
    HomeWarrantyAmountCentsFromJSON,
    HomeWarrantyAmountCentsFromJSONTyped,
    HomeWarrantyAmountCentsToJSON,
} from './HomeWarrantyAmountCents';
import type { LenderContactName } from './LenderContactName';
import {
    LenderContactNameFromJSON,
    LenderContactNameFromJSONTyped,
    LenderContactNameToJSON,
} from './LenderContactName';
import type { LenderEmail } from './LenderEmail';
import {
    LenderEmailFromJSON,
    LenderEmailFromJSONTyped,
    LenderEmailToJSON,
} from './LenderEmail';
import type { LenderName } from './LenderName';
import {
    LenderNameFromJSON,
    LenderNameFromJSONTyped,
    LenderNameToJSON,
} from './LenderName';
import type { LenderPhone } from './LenderPhone';
import {
    LenderPhoneFromJSON,
    LenderPhoneFromJSONTyped,
    LenderPhoneToJSON,
} from './LenderPhone';
import type { LoanId } from './LoanId';
import {
    LoanIdFromJSON,
    LoanIdFromJSONTyped,
    LoanIdToJSON,
} from './LoanId';
import type { ManualEntryReason } from './ManualEntryReason';
import {
    ManualEntryReasonFromJSON,
    ManualEntryReasonFromJSONTyped,
    ManualEntryReasonToJSON,
} from './ManualEntryReason';
import type { OfferSource } from './OfferSource';
import {
    OfferSourceFromJSON,
    OfferSourceFromJSONTyped,
    OfferSourceToJSON,
} from './OfferSource';
import type { ReceivedAt } from './ReceivedAt';
import {
    ReceivedAtFromJSON,
    ReceivedAtFromJSONTyped,
    ReceivedAtToJSON,
} from './ReceivedAt';
import type { SubmissionAdditionalTerms } from './SubmissionAdditionalTerms';
import {
    SubmissionAdditionalTermsFromJSON,
    SubmissionAdditionalTermsFromJSONTyped,
    SubmissionAdditionalTermsToJSON,
} from './SubmissionAdditionalTerms';

/**
 * Body for the external consumer offer submit → native transaction
 * (`POST /api/v1/public/transactions`).
 * 
 * Disposition-addressed analog of the 1.0 ``CreateOfferRequest`` (which keys
 * on ``listing_id``). The FE selects a combined-autocomplete option tagged
 * ``kind='disposition'`` and posts here with its ``disposition_id``; options
 * tagged ``kind='listing'`` stay on the unchanged 1.0 ``/api/v1/public/offers``
 * path.
 * @export
 * @interface CreatePublicTransactionRequest
 */
export interface CreatePublicTransactionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePublicTransactionRequest
     */
    dispositionId: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePublicTransactionRequest
     */
    buyerFullName: string;
    /**
     * 
     * @type {BuyerEmail}
     * @memberof CreatePublicTransactionRequest
     */
    buyerEmail?: BuyerEmail;
    /**
     * 
     * @type {BuyerPhone}
     * @memberof CreatePublicTransactionRequest
     */
    buyerPhone?: BuyerPhone;
    /**
     * 
     * @type {BuyerRepresentation}
     * @memberof CreatePublicTransactionRequest
     */
    buyerRepresentation: BuyerRepresentation;
    /**
     * 
     * @type {BuyerAgentFullName}
     * @memberof CreatePublicTransactionRequest
     */
    buyerAgentFullName?: BuyerAgentFullName;
    /**
     * 
     * @type {BuyerAgentEmail}
     * @memberof CreatePublicTransactionRequest
     */
    buyerAgentEmail?: BuyerAgentEmail;
    /**
     * 
     * @type {BuyerAgentPhone}
     * @memberof CreatePublicTransactionRequest
     */
    buyerAgentPhone?: BuyerAgentPhone;
    /**
     * 
     * @type {BuyerAgentBrokerage}
     * @memberof CreatePublicTransactionRequest
     */
    buyerAgentBrokerage?: BuyerAgentBrokerage;
    /**
     * 
     * @type {BuyerAgentLicenseNumber}
     * @memberof CreatePublicTransactionRequest
     */
    buyerAgentLicenseNumber?: BuyerAgentLicenseNumber;
    /**
     * 
     * @type {number}
     * @memberof CreatePublicTransactionRequest
     */
    offerPrice: number;
    /**
     * 
     * @type {Array<FinancingType>}
     * @memberof CreatePublicTransactionRequest
     */
    financingTypes: Array<FinancingType>;
    /**
     * 
     * @type {DownPayment}
     * @memberof CreatePublicTransactionRequest
     */
    downPayment?: DownPayment;
    /**
     * 
     * @type {number}
     * @memberof CreatePublicTransactionRequest
     */
    earnestMoneyDeposit: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePublicTransactionRequest
     */
    dueDiligencePeriodDays: number;
    /**
     * 
     * @type {DueDiligenceFee}
     * @memberof CreatePublicTransactionRequest
     */
    dueDiligenceFee?: DueDiligenceFee;
    /**
     * 
     * @type {AcceptanceDeadline}
     * @memberof CreatePublicTransactionRequest
     */
    acceptanceDeadline?: AcceptanceDeadline;
    /**
     * 
     * @type {string}
     * @memberof CreatePublicTransactionRequest
     */
    closingDate: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePublicTransactionRequest
     */
    titleCompany: string;
    /**
     * 
     * @type {ClientProposedTermsRequestBuyerAgentCommissionSource}
     * @memberof CreatePublicTransactionRequest
     */
    buyerAgentCommissionSource?: ClientProposedTermsRequestBuyerAgentCommissionSource;
    /**
     * 
     * @type {BuyerAgentCommissionFlatCents}
     * @memberof CreatePublicTransactionRequest
     */
    buyerAgentCommissionFlatCents?: BuyerAgentCommissionFlatCents;
    /**
     * 
     * @type {BuyerAgentCommissionPercentage1}
     * @memberof CreatePublicTransactionRequest
     */
    buyerAgentCommissionPercentage?: BuyerAgentCommissionPercentage1;
    /**
     * 
     * @type {AppraisalPeriodDays}
     * @memberof CreatePublicTransactionRequest
     */
    appraisalPeriodDays?: AppraisalPeriodDays;
    /**
     * 
     * @type {FinancingPeriodDays}
     * @memberof CreatePublicTransactionRequest
     */
    financingPeriodDays?: FinancingPeriodDays;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePublicTransactionRequest
     */
    requestSellerConcessions?: boolean;
    /**
     * 
     * @type {ConcessionsFlatCents}
     * @memberof CreatePublicTransactionRequest
     */
    concessionsFlatCents?: ConcessionsFlatCents;
    /**
     * 
     * @type {ConcessionsPercentage1}
     * @memberof CreatePublicTransactionRequest
     */
    concessionsPercentage?: ConcessionsPercentage1;
    /**
     * 
     * @type {SubmissionAdditionalTerms}
     * @memberof CreatePublicTransactionRequest
     */
    submissionAdditionalTerms?: SubmissionAdditionalTerms;
    /**
     * 
     * @type {AdditionalComments}
     * @memberof CreatePublicTransactionRequest
     */
    additionalComments?: AdditionalComments;
    /**
     * 
     * @type {HomeWarranty}
     * @memberof CreatePublicTransactionRequest
     */
    homeWarranty?: HomeWarranty;
    /**
     * 
     * @type {ClientProposedTermsRequestHomeWarrantyPaidBy}
     * @memberof CreatePublicTransactionRequest
     */
    homeWarrantyPaidBy?: ClientProposedTermsRequestHomeWarrantyPaidBy;
    /**
     * 
     * @type {HomeWarrantyAmountCents}
     * @memberof CreatePublicTransactionRequest
     */
    homeWarrantyAmountCents?: HomeWarrantyAmountCents;
    /**
     * 
     * @type {LenderName}
     * @memberof CreatePublicTransactionRequest
     */
    lenderName?: LenderName;
    /**
     * 
     * @type {LenderContactName}
     * @memberof CreatePublicTransactionRequest
     */
    lenderContactName?: LenderContactName;
    /**
     * 
     * @type {LenderEmail}
     * @memberof CreatePublicTransactionRequest
     */
    lenderEmail?: LenderEmail;
    /**
     * 
     * @type {LenderPhone}
     * @memberof CreatePublicTransactionRequest
     */
    lenderPhone?: LenderPhone;
    /**
     * 
     * @type {LoanId}
     * @memberof CreatePublicTransactionRequest
     */
    loanId?: LoanId;
    /**
     * 
     * @type {BuyerHomeMlsId}
     * @memberof CreatePublicTransactionRequest
     */
    buyerHomeMlsId?: BuyerHomeMlsId;
    /**
     * 
     * @type {CreateOfferRequestSource}
     * @memberof CreatePublicTransactionRequest
     */
    source?: CreateOfferRequestSource;
    /**
     * 
     * @type {ReceivedAt}
     * @memberof CreatePublicTransactionRequest
     */
    receivedAt?: ReceivedAt;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePublicTransactionRequest
     */
    sendEmail?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreatePublicTransactionRequest
     */
    helpscoutLink?: string;
    /**
     * 
     * @type {ManualEntryReason}
     * @memberof CreatePublicTransactionRequest
     */
    manualEntryReason?: ManualEntryReason;
    /**
     * 
     * @type {OfferSource}
     * @memberof CreatePublicTransactionRequest
     */
    offerSource?: OfferSource;
}

/**
 * Check if a given object implements the CreatePublicTransactionRequest interface.
 */
export function instanceOfCreatePublicTransactionRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "dispositionId" in value;
    isInstance = isInstance && "buyerFullName" in value;
    isInstance = isInstance && "buyerRepresentation" in value;
    isInstance = isInstance && "offerPrice" in value;
    isInstance = isInstance && "financingTypes" in value;
    isInstance = isInstance && "earnestMoneyDeposit" in value;
    isInstance = isInstance && "dueDiligencePeriodDays" in value;
    isInstance = isInstance && "closingDate" in value;
    isInstance = isInstance && "titleCompany" in value;

    return isInstance;
}

export function CreatePublicTransactionRequestFromJSON(json: any): CreatePublicTransactionRequest {
    return CreatePublicTransactionRequestFromJSONTyped(json, false);
}

export function CreatePublicTransactionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePublicTransactionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dispositionId': json['disposition_id'],
        'buyerFullName': json['buyer_full_name'],
        'buyerEmail': !exists(json, 'buyer_email') ? undefined : BuyerEmailFromJSON(json['buyer_email']),
        'buyerPhone': !exists(json, 'buyer_phone') ? undefined : BuyerPhoneFromJSON(json['buyer_phone']),
        'buyerRepresentation': BuyerRepresentationFromJSON(json['buyer_representation']),
        'buyerAgentFullName': !exists(json, 'buyer_agent_full_name') ? undefined : BuyerAgentFullNameFromJSON(json['buyer_agent_full_name']),
        'buyerAgentEmail': !exists(json, 'buyer_agent_email') ? undefined : BuyerAgentEmailFromJSON(json['buyer_agent_email']),
        'buyerAgentPhone': !exists(json, 'buyer_agent_phone') ? undefined : BuyerAgentPhoneFromJSON(json['buyer_agent_phone']),
        'buyerAgentBrokerage': !exists(json, 'buyer_agent_brokerage') ? undefined : BuyerAgentBrokerageFromJSON(json['buyer_agent_brokerage']),
        'buyerAgentLicenseNumber': !exists(json, 'buyer_agent_license_number') ? undefined : BuyerAgentLicenseNumberFromJSON(json['buyer_agent_license_number']),
        'offerPrice': json['offer_price'],
        'financingTypes': ((json['financing_types'] as Array<any>).map(FinancingTypeFromJSON)),
        'downPayment': !exists(json, 'down_payment') ? undefined : DownPaymentFromJSON(json['down_payment']),
        'earnestMoneyDeposit': json['earnest_money_deposit'],
        'dueDiligencePeriodDays': json['due_diligence_period_days'],
        'dueDiligenceFee': !exists(json, 'due_diligence_fee') ? undefined : DueDiligenceFeeFromJSON(json['due_diligence_fee']),
        'acceptanceDeadline': !exists(json, 'acceptance_deadline') ? undefined : AcceptanceDeadlineFromJSON(json['acceptance_deadline']),
        'closingDate': json['closing_date'],
        'titleCompany': json['title_company'],
        'buyerAgentCommissionSource': !exists(json, 'buyer_agent_commission_source') ? undefined : ClientProposedTermsRequestBuyerAgentCommissionSourceFromJSON(json['buyer_agent_commission_source']),
        'buyerAgentCommissionFlatCents': !exists(json, 'buyer_agent_commission_flat_cents') ? undefined : BuyerAgentCommissionFlatCentsFromJSON(json['buyer_agent_commission_flat_cents']),
        'buyerAgentCommissionPercentage': !exists(json, 'buyer_agent_commission_percentage') ? undefined : BuyerAgentCommissionPercentage1FromJSON(json['buyer_agent_commission_percentage']),
        'appraisalPeriodDays': !exists(json, 'appraisal_period_days') ? undefined : AppraisalPeriodDaysFromJSON(json['appraisal_period_days']),
        'financingPeriodDays': !exists(json, 'financing_period_days') ? undefined : FinancingPeriodDaysFromJSON(json['financing_period_days']),
        'requestSellerConcessions': !exists(json, 'request_seller_concessions') ? undefined : json['request_seller_concessions'],
        'concessionsFlatCents': !exists(json, 'concessions_flat_cents') ? undefined : ConcessionsFlatCentsFromJSON(json['concessions_flat_cents']),
        'concessionsPercentage': !exists(json, 'concessions_percentage') ? undefined : ConcessionsPercentage1FromJSON(json['concessions_percentage']),
        'submissionAdditionalTerms': !exists(json, 'submission_additional_terms') ? undefined : SubmissionAdditionalTermsFromJSON(json['submission_additional_terms']),
        'additionalComments': !exists(json, 'additional_comments') ? undefined : AdditionalCommentsFromJSON(json['additional_comments']),
        'homeWarranty': !exists(json, 'home_warranty') ? undefined : HomeWarrantyFromJSON(json['home_warranty']),
        'homeWarrantyPaidBy': !exists(json, 'home_warranty_paid_by') ? undefined : ClientProposedTermsRequestHomeWarrantyPaidByFromJSON(json['home_warranty_paid_by']),
        'homeWarrantyAmountCents': !exists(json, 'home_warranty_amount_cents') ? undefined : HomeWarrantyAmountCentsFromJSON(json['home_warranty_amount_cents']),
        'lenderName': !exists(json, 'lender_name') ? undefined : LenderNameFromJSON(json['lender_name']),
        'lenderContactName': !exists(json, 'lender_contact_name') ? undefined : LenderContactNameFromJSON(json['lender_contact_name']),
        'lenderEmail': !exists(json, 'lender_email') ? undefined : LenderEmailFromJSON(json['lender_email']),
        'lenderPhone': !exists(json, 'lender_phone') ? undefined : LenderPhoneFromJSON(json['lender_phone']),
        'loanId': !exists(json, 'loan_id') ? undefined : LoanIdFromJSON(json['loan_id']),
        'buyerHomeMlsId': !exists(json, 'buyer_home_mls_id') ? undefined : BuyerHomeMlsIdFromJSON(json['buyer_home_mls_id']),
        'source': !exists(json, 'source') ? undefined : CreateOfferRequestSourceFromJSON(json['source']),
        'receivedAt': !exists(json, 'received_at') ? undefined : ReceivedAtFromJSON(json['received_at']),
        'sendEmail': !exists(json, 'send_email') ? undefined : json['send_email'],
        'helpscoutLink': !exists(json, 'helpscout_link') ? undefined : json['helpscout_link'],
        'manualEntryReason': !exists(json, 'manual_entry_reason') ? undefined : ManualEntryReasonFromJSON(json['manual_entry_reason']),
        'offerSource': !exists(json, 'offer_source') ? undefined : OfferSourceFromJSON(json['offer_source']),
    };
}

export function CreatePublicTransactionRequestToJSON(value?: CreatePublicTransactionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'disposition_id': value.dispositionId,
        'buyer_full_name': value.buyerFullName,
        'buyer_email': BuyerEmailToJSON(value.buyerEmail),
        'buyer_phone': BuyerPhoneToJSON(value.buyerPhone),
        'buyer_representation': BuyerRepresentationToJSON(value.buyerRepresentation),
        'buyer_agent_full_name': BuyerAgentFullNameToJSON(value.buyerAgentFullName),
        'buyer_agent_email': BuyerAgentEmailToJSON(value.buyerAgentEmail),
        'buyer_agent_phone': BuyerAgentPhoneToJSON(value.buyerAgentPhone),
        'buyer_agent_brokerage': BuyerAgentBrokerageToJSON(value.buyerAgentBrokerage),
        'buyer_agent_license_number': BuyerAgentLicenseNumberToJSON(value.buyerAgentLicenseNumber),
        'offer_price': value.offerPrice,
        'financing_types': ((value.financingTypes as Array<any>).map(FinancingTypeToJSON)),
        'down_payment': DownPaymentToJSON(value.downPayment),
        'earnest_money_deposit': value.earnestMoneyDeposit,
        'due_diligence_period_days': value.dueDiligencePeriodDays,
        'due_diligence_fee': DueDiligenceFeeToJSON(value.dueDiligenceFee),
        'acceptance_deadline': AcceptanceDeadlineToJSON(value.acceptanceDeadline),
        'closing_date': value.closingDate,
        'title_company': value.titleCompany,
        'buyer_agent_commission_source': ClientProposedTermsRequestBuyerAgentCommissionSourceToJSON(value.buyerAgentCommissionSource),
        'buyer_agent_commission_flat_cents': BuyerAgentCommissionFlatCentsToJSON(value.buyerAgentCommissionFlatCents),
        'buyer_agent_commission_percentage': BuyerAgentCommissionPercentage1ToJSON(value.buyerAgentCommissionPercentage),
        'appraisal_period_days': AppraisalPeriodDaysToJSON(value.appraisalPeriodDays),
        'financing_period_days': FinancingPeriodDaysToJSON(value.financingPeriodDays),
        'request_seller_concessions': value.requestSellerConcessions,
        'concessions_flat_cents': ConcessionsFlatCentsToJSON(value.concessionsFlatCents),
        'concessions_percentage': ConcessionsPercentage1ToJSON(value.concessionsPercentage),
        'submission_additional_terms': SubmissionAdditionalTermsToJSON(value.submissionAdditionalTerms),
        'additional_comments': AdditionalCommentsToJSON(value.additionalComments),
        'home_warranty': HomeWarrantyToJSON(value.homeWarranty),
        'home_warranty_paid_by': ClientProposedTermsRequestHomeWarrantyPaidByToJSON(value.homeWarrantyPaidBy),
        'home_warranty_amount_cents': HomeWarrantyAmountCentsToJSON(value.homeWarrantyAmountCents),
        'lender_name': LenderNameToJSON(value.lenderName),
        'lender_contact_name': LenderContactNameToJSON(value.lenderContactName),
        'lender_email': LenderEmailToJSON(value.lenderEmail),
        'lender_phone': LenderPhoneToJSON(value.lenderPhone),
        'loan_id': LoanIdToJSON(value.loanId),
        'buyer_home_mls_id': BuyerHomeMlsIdToJSON(value.buyerHomeMlsId),
        'source': CreateOfferRequestSourceToJSON(value.source),
        'received_at': ReceivedAtToJSON(value.receivedAt),
        'send_email': value.sendEmail,
        'helpscout_link': value.helpscoutLink,
        'manual_entry_reason': ManualEntryReasonToJSON(value.manualEntryReason),
        'offer_source': OfferSourceToJSON(value.offerSource),
    };
}

